const getInnerFormFields = (parentKey, parentValue) => {
    let innerFormFields = {};
    if (parentValue.formType === 'formField') {
        innerFormFields[parentValue.id] = { ...parentValue };
    } else {
        const entries = Object.entries(parentValue);
        entries.forEach(([key, value]) => {
            if (parentKey === 'creditCardFields' && key === 'addressFields') {
                return;
            }
            if (value && value.formType === 'formField') {
                innerFormFields[key] = { ...value };
            }
            if (value && value.formType === 'formGroup') {
                innerFormFields = { ...innerFormFields, ...getInnerFormFields(key, value) };
            }
        });
    }
    return innerFormFields;
};

const getAllFormFields = (form) => {
    let formFields = {};
    const keys = Object.keys(form);
    keys.forEach((key) => {
        const value = form[key];
        if (value) {
            const innerFormFields = getInnerFormFields(key, value);
            formFields = { ...formFields, ...innerFormFields };
        }
    });
    return formFields;
};

const getLastFormData = (pdict) => {
    const lastFormData = {};

    const shippingForm = pdict.forms.shippingForm;
    const billingForm = pdict.forms.billingForm;

    if (shippingForm) {
        lastFormData.shipping = getAllFormFields(shippingForm, 'shipping');
    }
    if (billingForm) {
        lastFormData.billing = getAllFormFields(billingForm, 'billing');
    }

    return lastFormData;
};

export { getLastFormData };
